function pad(value: number): string {
  return value < 10 ? '0' + value : '' + value;
}

// Month, day, hour, minute in UTC (MMDD.HHmm) so a later build in the same year is a larger number.
// The year is left out on purpose so the visible text does not read as a date.
export function formatBuildStamp(builtAtIso: string): string {
  const builtAt = builtAtIso ? new Date(builtAtIso) : null;

  if (!builtAt || isNaN(builtAt.getTime())) {
    return 'local';
  }

  return pad(builtAt.getUTCMonth() + 1) + pad(builtAt.getUTCDate()) + '.' +
    pad(builtAt.getUTCHours()) + pad(builtAt.getUTCMinutes());
}
